import { FC } from "react";

export const HowToUse: FC = () => {
  return (
    <div className="mb-8 max-w-3xl text-neutral-700">
      <h2 className="text-lg font-semibold mb-3">
        How to Use This Service:
      </h2>

      <ol className="list-decimal pl-5 space-y-2 text-base">
        <li>
          Fill either the product description or the product customs code
          (HS code / Harmonized System code).
        </li>
        <li>Choose the originating country.</li>
        <li>Press the button <strong>“See EU tariff rates”</strong>.</li>
        <li>
          On the next screen, select the category that best matches your product.
        </li>
      </ol>
    </div>
  );
};
